module.exports = __webpack_public_path__ + "img/pocket.b6ef8e5b.jpg";